module.exports = __webpack_public_path__ + "img/icon-default.621c6c28.png";